import { translate } from 'hooks/useTranslate';

/* DATES */
export const INITIAL_DATE = '2022-01-01:00:00';
export const OLDEST_DATE = '1970-01-01:00:00';
export const DATE_FORMAT = 'dd/MM/yyyy';
export const DATE_FORMAT_LONG = 'PPP';
export const DATE_FORMAT_SHORT = 'dd/MM/yy';
export const DATE_FORMAT_MONTH_ONLY = 'MM/yyyy';
export const DATE_FORMAT_WITH_TIME = 'dd/MM/yyyy HH:mm';
export const DATE_FORMAT_WITH_TIME_ALT = 'dd MMM, yyyy hh:mm a';
export const TIME_FORMAT = 'hh:mm a';
export const DATE_FORMAT_API = 'yyyy-MM-dd';

/* OPTIONS LABELS */
export const ANADIR_SOCIO = translate('AddPartner');
export const ANADIR_CLASE = translate('AddClass');
export const SELECT_YEAR = translate('SelectAYear');
export const SELECT_OPTION = translate('Select');
export const SELECT_CATEGORY = translate('SelectCategory');
export const SELECCIONAR_SOCIO = translate('SelectPartner');
export const NUMERATE_FROM_START = translate('NumerateFromStart');

/* FILES */
export const MAX_FILESIZE_ALLOWED = { text: '50mb', value: 50000000 };
export const TYPE_FILES_ALLOWED = '.docx,.doc,.xls,.xlsx,.ppt,.pptx,.pdf';
export const TYPE_FILES_ALLOWED_UNSAFE = '.eml,.msg';
export const XLS_TYPE_FILE_ALLOWED = '.xls,.xlsx';
export const PDF_TYPE_FILE_ALLOWED = '.pdf';
export const EML_TYPE_FILE_ALLOWED = '.eml';

/* LOGOS */
export const BLANK_PROFILE_PICTURE = '/images/avatar/blank-profile.png';
export const BLANK_COMPANY_LOGO = '/images/avatar/blank-company.png';
export const STTOK_LOGO =
  process.env.REACT_APP_UI_MAIN_LOGO ||
  'https://www.resources.sttok.com/images/logo-dark.png';
export const STTOK_LOGO_2X =
  process.env.REACT_APP_UI_MAIN_LOGO ||
  'https://www.resources.sttok.com/images/logo-dark2x.png';

/* DOMAINS & URLS */
export const STTOK_EMAIL_DOMAIN = '@sttok.com';
export const STTOK_WEBSITE = 'https://www.sttok.com';
export const STTOK_DEMO_URL = 'https://calendly.com/sttok/30min';

/* LIMITS */
export const SEARCH_MIN_LENGTH = 3;
export const SEARCH_MAX_LENGTH = 50;
export const DOCUMENTS_ITEMS_PER_PAGE = 10;
export const COMMENTS_MAX_LENGTH = 1000;
export const MAX_PARTNERS_CAPTABLE = 20;
export const MAX_PARTNERS_BY_SOCIETY = 100;
export const MAX_PARTNERS_BY_PARTNER_BOOK = 1500;
export const MAX_PARTNERS_BY_DRAFTS = 1500;
export const MAX_PARTNERS_THRESHOLD = 1500;
export const MAX_PARTNERS_OPTIONS_COUNT = 100;
export const DAYS_FOR_DISPLAY_VESTING_MESSAGE = 7;

export const INACTIVITY_TIMEOUT = 15 * 60 * 1000; // minutes
export const INACTIVITY_MODAL_TIMER = 30 * 1000; // seconds
export const INACTIVITY_VERIFICATION_INTERVAL = 60 * 1000; // seconds

/* PATTERNS */
export const EMAIL_PATTERN = '[^@\\s]+@[^@\\s]+\\.[^@\\s]+';
export const GENERATED_EMAIL_PATTERN = /[0-9]{4}@sttok\.com$/i;

/* PDF */
export const JSPDF_MARGINS = {
  top: 40,
  bottom: 60,
  left: 40,
  width: 522,
};

/* THEMES */
export const DEFAULT_PRIMARY_COLOR = '#6576ff';
export const DEFAULT_HEADER_LOGO =
  process.env.REACT_APP_UI_MAIN_LOGO || '/images/logo-dark.png';
export const DEFAULT_HEADER_COLOR = '#ffffff';
export const DEFAULT_HEADER_TEXT_COLOR = '#6e82a5';
export const DEFAULT_HEADER_TEXT_HOVER_COLOR = '#6576ff';
export const DEFAULT_EMAIL_LOGO =
  process.env.REACT_APP_UI_MAIN_LOGO ||
  'https://www.resources.sttok.com/images/logo-dark2x.png';
export const DEFAULT_EMAIL_FRAME_LOGO =
  process.env.REACT_APP_UI_MAIN_LOGO || '/images/logo-dark.png';
export const DEFAULT_EMAIL_FRAME_COLOR = '#f5f6fa';
export const DEFAULT_EMAIL_HEADINGS_COLOR = '#6576ff';
export const DEFAULT_EMAIL_BODY_TEXT_COLOR = '#8094ae';
export const DEFAULT_EMAIL_LINK_COLOR = '#6576FF';
export const DEFAULT_EMAIL_BUTTON_COLOR = '#6576FF';
export const DEFAULT_EMAIL_BUTTON_TEXT_COLOR = '#ffffff';
export const DEFAULT_LOGO_HREF = '/';
export const DEFAULT_HEADER_FULL_WIDTH = false;
export const DEFAULT_HEADER_HEIGHT = 64;
export const DEFAULT_CONTENT_PADDING = 32;

export const APP_THEME_FF = 'app-theme';
export const DEFAULT_APP_THEME = 'light';

/* CURRENCY */
export const DEFAULT_CURRENCY = 'EUR';
